import { setTabs } from 'modules/common/Tabs/actions';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import ReportsContainer from 'modules/security/containers/ReportsContainer/index';
import { tabs } from './constants';

import TripsTabContainer from '../TripsTabContainer';
import TripContainer from '../TripContainer';
import Header from '../../../common/Header';
import Booking from '../Booking';

export const Ordering: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setTabs(tabs));
  }, []);

  return (
    <React.Fragment>
      <Header />
      <Switch>
        <Route path="/ordering" exact render={(props) => <TripsTabContainer {...props} lolomode={1} />} />
        <Route path="/ordering/unload" exact render={(props) => <TripsTabContainer {...props} lolomode={2} />} />
        <Route path="/ordering/reports" component={ReportsContainer} />
        <Route path="/ordering/booking" component={Booking} />
        <Route path="/ordering/trip/:tripId" component={TripContainer} exact />
      </Switch>
    </React.Fragment>
  );
};
